import styled, { css } from 'styled-components';
import Typography from '../../../../typography';
import { pxToRem } from '../../../../../design-tokens/style-utilities';
/**
 * Navigation link badge container
 */
export const navigationLinkBadgeContainerStyles = ({ theme }) => css `
	margin-left: ${pxToRem(theme.spacing['50'])};
	display: inline-flex;
	align-items: center;
	justify-content: center;
	padding: ${pxToRem(theme.spacing['50'])};
	border-radius: ${pxToRem(theme.borderRadius.s)};
	color: ${theme.colors.blanc.textInverse};
	background-color: ${theme.colors.promotional.bgLabel};
`;
export const NavigationLinkBadgeContainer = styled(Typography).attrs({
    variant: 'sticker-text-sm',
}) `
	${navigationLinkBadgeContainerStyles}
`;
